import React, { PureComponent } from "react";

import ColorName from "./Fields/ColorName";
import EngineTypeName from "./Fields/EngineTypeName";
import EngineCapacity from "./Fields/EngineCapacity";
import EngineValume from "./Fields/EngineValume";
import Vin from "./Fields/Vin";
import Osago from "./Fields/Osago";
import SteeringArrangement from "./Fields/SteeringArrangement";
import DriveUnitTypes from "./Fields/DriveUnitTypes";
import VehicleWeight from "./Fields/VehicleWeight";
import VehicleMaxWeight from "./Fields/VehicleMaxWeight";

class Section1 extends PureComponent {
  render() {
    const { disabled } = this.props; // , vehicleId
    const { form } = this.props;
    return (
      <div className="oneSectionArea">
        <div className="border-emmit" style={{ marginBottom: 24 }}></div>
        <div className="minWrap">
          <Vin form={form} disabled={disabled} />
          <Osago form={form} disabled={disabled} />
        </div>
        <div className="wrapper1" style={{ marginTop: "32px" }}>
          <ColorName form={form} disabled={disabled} />
          <SteeringArrangement form={form} disabled={disabled} />
          <DriveUnitTypes form={form} disabled={disabled} />
          <EngineTypeName form={form} disabled={disabled} />
          <EngineValume form={form} disabled={disabled} />
          <EngineCapacity form={form} disabled={disabled} />
          <VehicleWeight form={form} disabled={disabled} />
          <VehicleMaxWeight form={form} disabled={disabled} />
        </div>
        <div className="aHeight-3"></div>
      </div>
    );
  }
}

export default Section1;
